// The Notes app's writing tools — the actions and their labels. Mirrors the
// action keys in api/src/notebookWriting.js (keep in lockstep).

export const NOTEBOOK_WRITING_ACTIONS = [
  { key: "proofread", label: "Proofread", group: "edit" },
  { key: "rewrite", label: "Rewrite", group: "edit" },
  { key: "friendly", label: "Friendly", group: "edit" },
  { key: "professional", label: "Professional", group: "edit" },
  { key: "concise", label: "Concise", group: "edit" },
  { key: "summary", label: "Summary", group: "summarize" },
  { key: "keyPoints", label: "Key points", group: "summarize" },
  { key: "list", label: "List", group: "summarize" },
  { key: "table", label: "Table", group: "summarize" },
] as const;

export type NotebookWritingAction = (typeof NOTEBOOK_WRITING_ACTIONS)[number]["key"];

/** Summary-style results go BELOW the selection by default; edits replace it. */
export const notebookWritingReplacesByDefault = (action: string): boolean =>
  ["proofread", "rewrite", "friendly", "professional", "concise", "list", "table"].includes(action);
